import BaseService from './_base.service';

export const uploadService = {
    upload
};

function upload(image, callback) {
    return BaseService.postMultipart("/upload/", image, callback, true);
}
